class PdCartModal extends HTMLElement {
  constructor() {
    super();
    this.prevVariantIds = [];

    this.querySelector(".modal__close-button")?.addEventListener(
      "click",
      this.close.bind(this)
    );
    this.querySelector(".cart-empty__button")?.addEventListener(
      "click",
      this.close.bind(this)
    );
    this.show.bind(this);
    this.open.bind(this);
    this.close.bind(this);
    this.toggleLoading.bind(this);
    this.handleClickLoginLink();

    document.addEventListener("recommendations::loaded", (e) => {
      if (e.detail.isCartDrawer) {
        if (
          !document
            .querySelector("pd-cart-modal product-recommendations")
            ?.innerHTML.trim()
        ) {
          document
            .querySelector(
              'pd-cart-modal [data-section-type="ss-recommendations"]'
            )
            ?.classList.remove("d-none");
        }
      }
    });
  }

  handleClickLoginLink() {
    const cartLogin = this.querySelector("[data-cart-login]");

    if (cartLogin) {
      cartLogin?.addEventListener("click", () => {
        this.close();
        const returnTo = `${window.location.pathname}${window.location.search}`;

        if (typeof window.startCustomerAccountLogin === "function") {
          window.startCustomerAccountLogin({
            returnTo,
            action: "redirectTo",
          });
          return;
        }

        const encodedReturnTo = encodeURIComponent(returnTo);
        window.location.href = `/customer_authentication/login?return_to=${encodedReturnTo}`;
      });
    }
  }

  isOpen() {
    return this.classList.contains("active");
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  markRegistryCart() {
    document.body.setAttribute("registry-cart", "true");
  }

  unmarkRegistryCart() {
    document.body.removeAttribute("registry-cart");
  }

  show(event) {
    const self = this;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.querySelector("html").classList.add("overflow-hidden");
  }

  toggleLoading(open) {
    if (open) {
      this.querySelector("[data-loading-state]")?.classList?.remove("hidden");
    } else {
      this.querySelector("[data-loading-state]")?.classList?.add("hidden");
    }
  }

  async open(productHandle) {
    const self = this;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.classList.add("active");
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.querySelector("html").classList.add("overflow-hidden");

    this.toggleLoading(false);
  }

  close() {
    this.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.querySelector("html").classList.remove("overflow-hidden");
  }
}

customElements.define("pd-cart-modal", PdCartModal);
